// TODO: create test suite
// TODO: allow custom button disabling (e.g. "disable=['continue', 'back']")

import { Component, input, output } from '@angular/core';
@Component({
  selector: 'app-form-actions',
  templateUrl: './form-actions.component.html',
  styleUrl: './form-actions.component.scss',
})
export class FormActionsComponent {
  // Input to determine the current step
  public readonly step = input<'first' | 'last' | undefined>();

  // Input to control if the continue/finish button is disabled
  public readonly isFormInvalid = input.required<boolean>();

  // Output events for each action
  public readonly back = output<void>();
  public readonly continue = output<void>();
  public readonly finish = output<void>();

  // Methods that emit the corresponding events
  public onBack(): void {
    this.back.emit();
  }

  public onContinue(): void {
    this.continue.emit();
  }

  public onFinish(): void {
    this.finish.emit();
  }
}